import { render, staticRenderFns } from "./TuitionBroadcast.vue?vue&type=template&id=06a6afed&"
import script from "./TuitionBroadcast.vue?vue&type=script&lang=js&"
export * from "./TuitionBroadcast.vue?vue&type=script&lang=js&"
import style0 from "./TuitionBroadcast.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports